import PropTypes from 'prop-types';

const basic_auth_props_types = {
  app: PropTypes.string,
  host: PropTypes.string,
  plid: PropTypes.number,
  path: PropTypes.string,
  port: PropTypes.string,
  realm: PropTypes.string,
  market: PropTypes.string,
  locale: PropTypes.object,
  version: PropTypes.string,
  is_china: PropTypes.bool,
  auth_type: PropTypes.string,
  url_params: PropTypes.object,
  is_reseller: PropTypes.bool,
  traffic_prefix: PropTypes.string,
};

export default basic_auth_props_types;
